import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TimeSlot } from 'src/app/classes/TimeSlot';

@Component({
  selector: 'app-timeslot',
  templateUrl: './timeslot.component.html',
  styleUrls: ['./timeslot.component.scss'],
})
export class TimeslotComponent implements OnInit, OnChanges {

  @Input()
  timeslot: TimeSlot[] = [];

  @Input()
  editable: boolean = true;

  @Output('changedTimeslots')
  public changedTimeslots: EventEmitter<TimeSlot[]> = new EventEmitter();
  public form: FormGroup;

  public timeslots: FormArray;
  public minuteValues = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

  public daysSelect = [
    { value: 0, label: 'Monday' },
    { value: 1, label: 'Tuesday' },
    { value: 2, label: 'Wednesday' },
    { value: 3, label: 'Thursday' },
    { value: 4, label: 'Friday' },
    { value: 5, label: 'Saturday' },
    { value: 6, label: 'Sunday' }
  ];

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.timeslots)
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      timeslot: this.formBuilder.array([]) // Empty formarray
    });
    this.timeslots = this.form.get('timeslot') as FormArray;
    this.loadTimeslot();
  }

  saveTimeslots(): void {
    // Form deep copy to avoid data propagation to form
    const timeslots = JSON.parse(JSON.stringify(this.form.get('timeslot').value));
    if (timeslots && timeslots.length > 0) {
      timeslots.forEach(item => {
        item.startMillis = this.displayDayToMillis(item.startDay) + this.displayTimeToMillis(new Date(item.startMillis));
        item.endMillis = this.displayDayToMillis(item.endDay) + this.displayTimeToMillis(new Date(item.endMillis));
        if (item.discount) {
          item.discount.percentageDiscountOnActiveFee ? item.discount.percentageDiscountOnActiveFee /= 100 : null;
          item.discount.percentageDiscountOnBookingFee ? item.discount.percentageDiscountOnBookingFee /= 100 : null;
          item.discount.percentageDiscountOnBreakFee ? item.discount.percentageDiscountOnBreakFee /= 100 : null;
          item.discount.percentageDiscountOnKmFee ? item.discount.percentageDiscountOnKmFee /= 100 : null;
          item.discount.percentageDiscountOnSeasonTicketFee ? item.discount.percentageDiscountOnSeasonTicketFee /= 100 : null;
          item.discount.percentageDiscountOnUnlockFee ? item.discount.percentageDiscountOnUnlockFee /= 100 : null;
        }
      });
    }
    this.changedTimeslots.emit(timeslots as TimeSlot[]);
  }
  
  

  addTimeslot(): void {
    const timeslotGroup = this.buildForm(null);
    this.timeslots.push(timeslotGroup);  // Add new Timeslot FormGroup
  }

  loadTimeslot() {
    if (this.timeslot) {
      this.timeslot.forEach(item => {
        const timeslotGroup = this.buildForm(item);
        this.timeslots.push(timeslotGroup)
      });
    }
  }

  removeTimeslot(index: number): void {
    this.timeslots.removeAt(index);  // Remove FormGroup by specified index
    this.saveTimeslots();
  }

  millisToDisplayTime(millis: number) {
    const mins = Math.floor((millis / (1000 * 60)) % 60);
    const hrs = Math.floor((millis / (1000 * 60 * 60)) % 24);

    const displayHrs = (hrs < 10) ? 0 + hrs : hrs;
    const displayMins = (mins < 10) ? 0 + mins : mins;

    const currentDate = new Date();
    currentDate.setHours(displayHrs);
    currentDate.setMinutes(displayMins);

    return currentDate.toISOString();
  }

  displayDayToMillis(day) {
    return parseInt(day) * 24 * 60 * 60 * 1000;
  }

  displayTimeToMillis(time) {
    const hrs = time.getHours();
    const mins = time.getMinutes();

    const hrsToMillis = hrs * 60 * 60 * 1000;
    const minsToMillis = mins * 60 * 1000;
    return hrsToMillis + minsToMillis;
  }

  millisToDisplayDay(millis: number): number {
    const millisPerDay = 24 * 60 * 60 * 1000;
    return Math.floor(millis / millisPerDay);
  }

  private buildForm(item: TimeSlot | null): FormGroup {
    return this.formBuilder.group({
      id: [item ? item.id : null, []],
      startDay: [item ? this.millisToDisplayDay(item.startMillis) : null, [Validators.required]],
      startMillis: [item ? this.millisToDisplayTime(item.startMillis) : null, [Validators.required]],
      endDay: [item ? this.millisToDisplayDay(item.endMillis) : null, [Validators.required]],
      endMillis: [item ? this.millisToDisplayTime(item.endMillis) : null, [Validators.required]],
      discount: this.formBuilder.group({
        percentageDiscountOnActiveFee: [(item && item.discount.percentageDiscountOnActiveFee) ? item.discount.percentageDiscountOnActiveFee*100 : null, [Validators.max(100), Validators.pattern('^(?!0(\\.0+)?$)(-?\\d+(\\.\\d+)?)$')]],
        flatDiscountOnActiveFee: [item ? item.discount.flatDiscountOnActiveFee : null, []],
        percentageDiscountOnBreakFee: [(item && item.discount.percentageDiscountOnBreakFee) ? item.discount.percentageDiscountOnBreakFee*100 : null, [Validators.max(100), Validators.pattern('^(?!0(\\.0+)?$)(-?\\d+(\\.\\d+)?)$')]],
        flatDiscountOnBreakFee: [item ? item.discount.flatDiscountOnBreakFee : null, []],
        percentageDiscountOnUnlockFee: [(item && item.discount.percentageDiscountOnUnlockFee) ? item.discount.percentageDiscountOnUnlockFee*100 : null, [Validators.max(100), Validators.pattern('^(?!0(\\.0+)?$)(-?\\d+(\\.\\d+)?)$')]],
        flatDiscountOnUnlockFee: [item ? item.discount.flatDiscountOnUnlockFee : null, []],
        percentageDiscountOnBookingFee: [(item && item.discount.percentageDiscountOnBookingFee) ? item.discount.percentageDiscountOnBookingFee*100 : null, [Validators.max(100), Validators.pattern('^(?!0(\\.0+)?$)(-?\\d+(\\.\\d+)?)$')]],
        flatDiscountOnBookingFee: [item ? item.discount.flatDiscountOnBookingFee : null, []],
        percentageDiscountOnSeasonTicketFee: [(item && item.discount.percentageDiscountOnSeasonTicketFee) ? item.discount.percentageDiscountOnSeasonTicketFee*100 : null, [Validators.max(100), Validators.pattern('^(?!0(\\.0+)?$)(-?\\d+(\\.\\d+)?)$')]],
        flatDiscountOnSeasonTicketFee: [item ? item.discount.flatDiscountOnSeasonTicketFee : null, []],
        percentageDiscountOnKmFee: [(item && item.discount.percentageDiscountOnKmFee) ? item.discount.percentageDiscountOnKmFee*100 : null, [Validators.max(100), , Validators.pattern('^(?!0(\\.0+)?$)(-?\\d+(\\.\\d+)?)$')]],
        flatDiscountOnKmFee: [item ? item.discount.flatDiscountOnKmFee : null, []],
        maxFreeUnlockDaily: [item ? item.discount.maxFreeUnlockDaily : 0, [Validators.min(0)]],
        freeUnlockThreshold: [item ? item.discount.freeUnlockThreshold : -1, [Validators.min(-1)]]
      })
    });
  }

}
